import React from 'react';
import { useMyLeases } from '@/hooks/useTenantLease';
import UITenancyOverview, {
  TenancyProperty,
} from '../../../components/shared/UITenancyOverwiev/UITenancyOverwiev';
import { MyLease } from '@/api/lease';
import './TenancyPage.scss';

const TenancyPage = () => {
  const { data: leases, isLoading, isError } = useMyLeases();

  // Маппер для перетворення даних з API у пропси для компонента
  const leasesToProperties = (leasesData: MyLease[]): TenancyProperty[] => {
    if (!leasesData) {
      return [];
    }
    return leasesData.map((lease) => {
      const { address } = lease.unit.property;
      const fullAddress = address
        ? `${address.street} ${address.buildingNumber}, ${address.city}`
        : 'Address not available';

      return {
        id: lease.id.toString(),
        name: lease.unit.property.name,
        type: lease.unit.property.type as 'residential' | 'commercial' | 'mixed' | undefined | null,
        address: fullAddress,
        unit: lease.unit.number,
        latitude: address?.latitude || null,
        longitude: address?.longitude || null,
        payment: {
          status: 'PENDING', // Заглушка, потрібна логіка для визначення статусу
          rental: `$${lease.monthlyRent}`,
          debt: '$0.00', // Заглушка
          nextPayment: lease.firstPaymentDate || 'N/A',
          leaseExpiration: lease.endDate || 'N/A',
          paymentMethod: lease.paymentMethod || 'N/A',
          warnings: 0, // Заглушка
          canPayOnline: true, // Заглушка
        },
        // Обробники подій
        onPropertyInfo: (propertyId: string) =>
          console.log(`Info for ${propertyId}`),
        onContactProperty: (propertyId: string) =>
          console.log(`Contact for ${propertyId}`),
        onReportWarning: (propertyId: string) =>
          console.log(`Warning for ${propertyId}`),
        onMakePayment: (propertyId: string) =>
          console.log(`Payment for ${propertyId}`),
      };
    });
  };

  if (isLoading) {
    return <div className="TenancyPage">Loading...</div>;
  }

  if (isError) {
    return <div className="TenancyPage">Error fetching leases.</div>;
  }

  const properties: TenancyProperty[] = leases
    ? leasesToProperties(leases)
    : [];

  return (
    <div className="TenancyPage">
      {properties.length > 0 ? (
        <UITenancyOverview title="My Tenancy" properties={properties} />
      ) : (
        <p>You have no leases.</p>
      )}
    </div>
  );
};

export default TenancyPage;
